var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDetailTc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.166,
    height: 15.172,
    viewBox: "0 0 15.166 15.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "window",
    d: "M8.215,3.788H3.16A3.161,3.161,0,0,0,0,6.947V12a3.161,3.161,0,0,0,3.16,3.16H8.215A3.161,3.161,0,0,0,11.374,12V6.947A3.161,3.161,0,0,0,8.215,3.788ZM3.16,5.052H8.215a1.9,1.9,0,0,1,1.9,1.9H1.264A1.9,1.9,0,0,1,3.16,5.052ZM8.215,13.9H3.16a1.9,1.9,0,0,1-1.9-1.9V8.211h8.847V12A1.9,1.9,0,0,1,8.215,13.9ZM15.166,3.156v5.4a3.171,3.171,0,0,1-1.58,2.736.636.636,0,0,1-.638-1.1A1.9,1.9,0,0,0,13.9,8.546V3.156A1.9,1.9,0,0,0,12,1.26H6.61a1.913,1.913,0,0,0-1.643.948A.633.633,0,1,1,3.874,1.57,3.171,3.171,0,0,1,6.61-.01h5.4a3.161,3.161,0,0,1,3.16,3.16Z",
    transform: "translate(0 0.01)",
    fill: "#868687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetailTc);
export default __webpack_public_path__ + "static/media/icon_detail_TC.5abc275ef03f27e8330f69b15651b752.svg";
export { ForwardRef as ReactComponent };